var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holidayguru"},[_c('HgFooterNew',{attrs:{"lang":_vm.lang,"activate-cookie-consent":!_vm.noCookieConsent,"showAccessibilityDeclaration":true},on:{"onCookieButtonClick":_vm.cookieButtonClick,"onNewsletterButtonClick":_vm.newsletterButtonClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }